import type { ImageType } from 'models/Image';

import { ImageFilters } from 'models/ImageFilters';
import HTTP from '../../helpers/http';

export const imagesService = {
  getImages: (params: ImageFilters) => HTTP.get<{ docs: ImageType[]; totalDocs: number }>(`/images?${params.searchParams()}`),
};
